export default {
  sm: `
  We share the world-class security 
  technology that has procected NAVER 
  services from countless attacks occurring 
  within just one second in a secure manner 
  for 20 years.    
  `,
  md: `
  We share the world-class security 
  technology that has procected NAVER 
  services from countless attacks occurring 
  within just one second in a secure manner 
  for 20 years.    
  `,
  lg: `
  We share the world-class security technology that has 
  procected NAVER services from countless attacks 
  occurring within just one second in a secure manner for 
  20 years.    
  `,
  xxl: `
  We share the world-class security technology
  that has procected NAVER services from
  countless attacks occurring within just one 
  second in a secure manner for 20 years.    
  `,
};
